(function () {
  "use strict";

  var MIN_COUNT = 1;
  var MAX_COUNT = 200;
  var FALLBACK_DIAMETER = 390;
  var FALLBACK_STEP = 67;
  var RESIZE_DEBOUNCE = 200;
  // Matches $tablet in breakpoint.scss — mobile layout is max-width 1365.
  var TABLET_QUERY = "(max-width: 1365px)";

  function readGeometry(span) {
    if (!span) {
      return { diameter: FALLBACK_DIAMETER, step: FALLBACK_STEP };
    }

    var styles = window.getComputedStyle(span);
    var diameter =
      parseFloat(styles.minWidth) ||
      parseFloat(styles.width) ||
      span.getBoundingClientRect().width;
    var marginRight = parseFloat(styles.marginRight);
    var step = diameter + marginRight;

    if (!(diameter > 0) || !(step > 0)) {
      return { diameter: FALLBACK_DIAMETER, step: FALLBACK_STEP };
    }

    return { diameter: diameter, step: step };
  }

  function neededCount(width, diameter, step) {
    var count = 1 + Math.round((width - diameter) / step);

    if (count < MIN_COUNT) {
      return MIN_COUNT;
    }

    if (count > MAX_COUNT) {
      return MAX_COUNT;
    }

    return count;
  }

  function syncSpirals(wrap) {
    var width = wrap.clientWidth;

    if (width <= 0) {
      return;
    }

    var sample = wrap.querySelector("span");
    var geometry = readGeometry(sample);
    var count = neededCount(width, geometry.diameter, geometry.step);
    var spans = wrap.querySelectorAll("span");
    var current = spans.length;
    var i;
    var span;

    if (current === count) {
      return;
    }

    for (i = current; i < count; i += 1) {
      span = document.createElement("span");
      span.innerHTML = "&nbsp;";
      wrap.appendChild(span);
    }

    for (i = current; i > count; i -= 1) {
      span = wrap.querySelector("span:last-of-type");

      if (!span) {
        break;
      }

      wrap.removeChild(span);
    }
  }

  function initSeparator(wrap) {
    if (!wrap || wrap.dataset.spiralBound === "1") {
      return;
    }

    syncSpirals(wrap);

    if (typeof window.ResizeObserver === "function") {
      var observer = new window.ResizeObserver(function () {
        syncSpirals(wrap);
      });

      observer.observe(wrap);
    } else {
      var resizeTimer;

      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          syncSpirals(wrap);
        }, RESIZE_DEBOUNCE);
      });
    }

    if (typeof window.matchMedia === "function") {
      var tabletMq = window.matchMedia(TABLET_QUERY);
      var onBreakpoint = function () {
        syncSpirals(wrap);
      };

      if (typeof tabletMq.addEventListener === "function") {
        tabletMq.addEventListener("change", onBreakpoint);
      } else if (typeof tabletMq.addListener === "function") {
        tabletMq.addListener(onBreakpoint);
      }
    }

    wrap.dataset.spiralBound = "1";
  }

  function initSeparators() {
    document.querySelectorAll("[data-spiral-wrap]").forEach(initSeparator);
  }

  window.initSeparators = initSeparators;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSeparators);
  } else {
    initSeparators();
  }
})();
